import type { Translate } from '@realadvisor/translator/engine';
import { Monitor, Moon, Sun } from 'lucide-react';

export const getThemeMenuOptions = (t: Translate) =>
  [
    { value: 'light', label: t('Light'), Icon: Sun },
    { value: 'dark', label: t('Dark'), Icon: Moon },
    { value: 'system', label: t('System'), Icon: Monitor },
  ] as const;
